<script>
  export default {
    name: 'IconTitle',
    props: {
      title: {
        type: String,
        required: true,
        default: ''
      },
      icon: {
        type: String,
        required: false,
        default: null
      }
    },
    computed: {
      iconPath () {
        return require(`@/assets/svg/${this.icon}.svg`)
      }
    }
  }
</script>

<template>
  <div class="icon-title">
    <img v-if="icon" :src="iconPath" :alt="title">
    <h3 class="icon-title__title"><strong>{{ title }}</strong></h3>
  </div>
</template>

<style lang="scss" scoped>
  .icon-title {
    display: grid;
    grid-template-columns: 32px auto;
    gap: 12px;
    align-items: center;
    margin-bottom: 16px;

    &__title {
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 0;
    }
  }
</style>
